import moment from "moment";

/**
 * @author：ww
 * @function: 对象深度拷贝
 * @prams: source 需要拷贝的对象 必填
 */
const deepCopy = (source) => {
  const result = Array.isArray(source) ? [] : {};
  for (const key in source) {
    if (typeof source[key] === "object" && source[key] !== null) {
      result[key] = deepCopy(source[key]);
    } else {
      result[key] = source[key];
    }
  }
  return result;
};

/**
 * @author：px
 * @function: 对象合并操作
 */
const merge = (dest, res) => {
  return Object.assign({}, dest, res);
};

const deepMerge = (obj1, obj2) => {
  let result = {};
  if (typeof obj1 !== "object" || typeof obj2 !== "object") {
    return result;
  }
  for (let key in obj1) {
    if (Object.prototype.hasOwnProperty.call(obj1, key)) {
      if (Object.prototype.hasOwnProperty.call(obj2, key)) {
        if (typeof obj1[key] === "object" && typeof obj2[key] === "object") {
          result[key] = deepMerge(obj1[key], obj2[key]);
        } else {
          result[key] = obj2[key];
        }
      } else {
        result[key] = obj1[key];
      }
    }
  }
  for (let key in obj2) {
    if (Object.prototype.hasOwnProperty.call(obj2, key)) {
      if (Object.prototype.hasOwnProperty.call(result, key)) {
        result[key] = obj2[key];
      }
    }
  }
  return result;
};

const isNull = (value) => {
  return [null, undefined, ""].includes(value);
};

const dateFormatByMoment = (currentDate, formatStr = "YYYY-MM-DD HH:mm:ss") => {
  if (isNull(currentDate)) {
    return "";
  }
  return moment(currentDate).format(formatStr);
};

/**
 * @author：qm
 * @function: 限制小数位
 * @pramas: 1.value  需校验的数值
 *            2._len  限制的小数位数
 */
const numberToFixed = (value, _len = 2) => {
  if (isNull(value)) {
    return "";
  }
  const num = parseFloat(value);
  if (isNaN(num)) {
    return value;
  }
  return num.toFixed(_len);
};

/**
 * @author：
 * @function: 保留小数，不补0 && 四舍五入
 * @params: {
 *   value, // 当前值
 *   _len, // 保留几位小数
 * }
 */
const numberDigits = (value, _len = 2) => {
  if (isNull(value)) {
    return "";
  }
  const num = parseFloat(value);
  if (isNaN(num)) {
    return value;
  }
  return Math.round(num * Math.pow(10, _len)) / Math.pow(10, _len);
};

/**
 * @author：qm
 * @function: 数字转千分位格式
 * @pramas: num
 */
const formatNumberByKSeparator = (num) => {
  if (typeof num !== "number") {
    return num;
  }
  const reg = /\d{1,3}(?=(\d{3})+(?!\d))/g;
  return (num + "").replace(reg, "$&,");
};

/**
 * 如果非空则返回该值，否则返回指定值
 * @param {Object} val
 * @param {Object} defaultVal
 */
const getValueByDefault = (val, defaultVal) => {
  if (isNull(val)) {
    return val;
  }
  return defaultVal;
};

/**
 * @author: 史艳玲
 * el-table合并单元格 处理某列相同行数据
 * @param {*} data : 表格数据 tableData
 * @param {*} key : 对应的合并字段（field）
 * @returns
 */
const getArrSameSpan = (data, key) => {
  let pos = 0,
    arrSameSpan = [];
  for (let i = 0; i < data.length; i++) {
    if (i === 0) {
      arrSameSpan.push(1);
      // pos = 0
    } else {
      // 判断当前元素与上一个元素是否相同
      if (data[i][key] === data[i - 1][key] && data[i][key]) {
        arrSameSpan[pos] += 1;
        arrSameSpan.push(0);
      } else {
        arrSameSpan.push(1);
        pos = i;
      }
    }
  }
  return arrSameSpan;
};

/**
 * * 获取URL中带的链接参数
 * @param search 链接后缀
 * @return {{}} 对象
 * @returns
 */
const getUrlParams = (search) => {
  search = search || location.search;
  const paramsSplit = search.replace(/^[^\?]*\?/i, "").split("&");
  const params = {};
  if (Array.isArray(paramsSplit)) {
    paramsSplit.forEach((item) => {
      const itemSplit = item.split("=");
      params[itemSplit[0]] = itemSplit[1];
    });
  }
  return params;
};

/*
 * 获取数组对应参数且转为对象
 * items: 数组
 */
const getModelObj = (objSelectForm) => {
  let model = {};
  objSelectForm.arrFormItem.forEach((item) => {
    if (item.prop) {
      model[item.prop] = item.defaultVal || "";
    }
  });
  Object.assign(model, objSelectForm.model);
  return model;
};

export default {
  deepCopy,
  merge,
  deepMerge,
  isNull,
  numberToFixed,
  numberDigits,
  formatNumberByKSeparator,
  dateFormatByMoment,
  getValueByDefault,
  getArrSameSpan,
  getUrlParams,
  getModelObj,
};
